import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, NavigationEnd } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { FileSaverModule } from 'ngx-filesaver';
import { Observable, asyncScheduler, of, throwError } from 'rxjs';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { SeguridadService, infoAuditoria } from 'src/app/services/seguridad.service';
import { AuthService } from '../auth.service';
import { SharedServiceService } from '../shared-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizedGuard  {
  selectedEntidad$: Observable<number | null>;
  iIDEntidad: any;
  selectedPerfil$: Observable<number>;
  iIDPerfil: any;
  unixTimestamp = 0;
  selectedTime$: Observable<number | null>;
  timeExpire: any;
  auditoria?: infoAuditoria;

  constructor(private seguridadService: SeguridadService,
    private router: Router,
    private nbAuthService: NbAuthService,
    private authService: AuthService,
    private _sharedService: SharedServiceService) {
    this.selectedEntidad$ = nbAuthService.onTokenChange().pipe(
      map(token => +token.getPayload().iIDEntidad)
    );
    this.selectedEntidad$.subscribe(idEntidad => {
      this.iIDEntidad = idEntidad;
    })

    this.selectedPerfil$ = nbAuthService.onTokenChange().pipe(
      map(token => +token.getPayload().iIDPerfil)
    );
    this.selectedPerfil$.subscribe(idPerfil => {
      this.iIDPerfil = idPerfil;
    })
    this.selectedTime$ = nbAuthService.onTokenChange().pipe(
      map(token => +token.getPayload().timeExpire)
    );
    this.selectedTime$.subscribe(time => {
      this.timeExpire = time;
    })
    // console.log("Autorized time: ", this.timeExpire);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this._sharedService.resetAuditExecuted();
    });

  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot
  ): Observable<boolean> {
    let url: string;
    let tUrl: string;
    if (childRoute.queryParams.url) {
      url = childRoute.queryParams.url;
      let urlGeneral = url.split('/');
      tUrl = '/' + urlGeneral[urlGeneral.length - 3] + '/' + urlGeneral[urlGeneral.length - 2] + '/' + urlGeneral[urlGeneral.length - 1];
    } else {
      url = '/' + childRoute.pathFromRoot.flatMap(x => x.url).join('/');
      tUrl = url;
    }

    return this.seguridadService.check(url).pipe(
      tap(x => {
        sessionStorage.setItem('params', JSON.stringify(x))
        this.authService.updateToken(this.iIDEntidad, this.iIDPerfil, this.timeExpire).pipe(
          switchMap(auth => {
            if (auth) {
              return this.nbAuthService.getToken().pipe(
                map(token => {
                  if (token.getPayload() != null) {
                    if (token.isValid()) {
                      if (!this._sharedService.isAuditExecuted()) {
                        this._sharedService.markAuditExecuted(); // Marcamos que ya se ejecutó la auditoría

                        const parts = url.split('/');
                        const componente = parts[parts.length - 1];
                        this.auditoria = {
                          tFormulario: tUrl,
                          tDescripcion: " El usuario " + token.getPayload().name + " ha ingresado al componente " + componente,
                        }

                        this.seguridadService.setAuditoria(this.auditoria).subscribe();
                        // Fin del bloque de auditoría
                      }
                      //this.seguridadService.setAuditoria(this.auditoria).subscribe();
                      this.unixTimestamp = token.getPayload().exp;
                      const date = new Date(this.unixTimestamp * 1000);
                      const dateNow = new Date();
                      let secondsSend = date.getTime() - dateNow.getTime();
                      secondsSend = secondsSend / 1000;
                      let secondsTimer = Math.floor(secondsSend);
                      this._sharedService.emitChange({
                        defaultTimeoutSeconds: secondsTimer,
                        defaultShowPopupSeconds: 60,
                        dateExp: this.unixTimestamp
                      });

                      const iIDEntidadMonedaLocal = token.getPayload().iIDEntidadMonedaLocal;
                      asyncScheduler.schedule(() => {
                        this._sharedService.emitToken(iIDEntidadMonedaLocal);
                      });

                      // console.log("Actualizo el token");
                      // this.boMostrarSpinner = false;
                      return true;
                    }
                    return false;
                  } else {
                    return false;
                  }
                })
              );
            } else {
              this.router.navigateByUrl('/auth/loginDav');
              return of(false);
            }
          })
        ).subscribe(result => {
          if (result) {
            // Realizar acciones adicionales si es necesario despues de suscribirse a updatetoken
          }
        }, error => {
          console.error(error);
        });
      }),
      catchError(() => {
        this.router.navigate(['auth/Logout']);
        return throwError('Unauthorized');
      }
      ),
      map(x => !!x)
    );
  }
}
